// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.formBoxPanel {
  margin: 0px;
  padding: 0px;
}
.formBoxPanelDebug {
  position: relative;
  margin: 0px;
  padding: 5px;
  border: solid 1px #4D5FE2;
}
.formBoxPanelDebugText {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: -1;
  overflow: hidden;
  color: #4D5FE2;
}
`, "",{"version":3,"sources":["webpack://./src/app/Controls/Core/FormBoxPanel.less"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,YAAA;AADF;AAIA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;AAFF;AAKA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AAHF","sourcesContent":["@import '~common-controls/Style/Colors.less';\n\n.formBoxPanel {\n  margin: 0px;\n  padding: 0px;\n}\n\n.formBoxPanelDebug {\n  position: relative;\n  margin: 0px;\n  padding: 5px;\n  border: solid 1px @info-color;\n}\n\n.formBoxPanelDebugText {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: -1;\n  overflow: hidden;\n  color: @info-color;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
